import React from 'react'
import { FormattedMessage } from 'react-intl'
import { TooltipLabel } from '../../../design-system'
import { attackStatusi18nConfig, isValidStatus } from '../../attack-status'
import { TooltipLabelText } from './tooltip-label-text'

const determineI18nID = (
  hasAProtectedServer: boolean,
  attackStatus?: string
) => {
  if (!hasAProtectedServer) {
    return 'detail_protectIsOff'
  }
  if (attackStatus && isValidStatus(attackStatus)) {
    return attackStatusi18nConfig[attackStatus]
  }
  return 'detail_attacks_noAttackDetected'
}

export function AttackStatus({
  attackStatus,
  hasAProtectedServer
}: {
  readonly attackStatus?: string
  readonly hasAProtectedServer: boolean
}) {
  return (
    <FormattedMessage id="title_status">
      {(label) => {
        return (
          <TooltipLabel
            label={label as any}
            renderValue={() => {
              return (
                <FormattedMessage
                  id={determineI18nID(hasAProtectedServer, attackStatus)}
                >
                  {(text) => {
                    return <TooltipLabelText>{text}</TooltipLabelText>
                  }}
                </FormattedMessage>
              )
            }}
          />
        )
      }}
    </FormattedMessage>
  )
}
